import { Home } from "lucide-react";

export function Header({ count }: { count: number }) {
  return (
    <header className="sticky top-0 z-40 w-full backdrop-blur-xl bg-background/80 border-b border-border/50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
            <Home className="w-4 h-4 text-primary" />
          </div>
          <div>
            <h1 className="font-display text-lg font-semibold tracking-tight leading-none">
              Hemnet Moodboard
            </h1>
            <p className="text-[11px] text-muted-foreground tracking-widest uppercase mt-0.5">
              Din bostadssamling
            </p>
          </div>
        </div>

        {count > 0 && (
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary/10 text-primary font-semibold text-[11px]">
              {count}
            </span>
            <span className="hidden sm:inline tracking-wide">
              {count === 1 ? "bostad" : "bostäder"}
            </span>
          </div>
        )}
      </div>
    </header>
  );
}
